export enum Fonte {
    Default = 0,
    Calibri = 1,
    Monospace = 2,
    Courier = 3,
    Helvetica = 4,
    TimesRoman = 5,
}
